module.exports = __webpack_public_path__ + "img-front/register/kinesis-fourth.3f6c2709.svg";